import EditorPage from "./editor";

export default EditorPage;
